"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.number.to-fixed.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _report = require("@/api/report.api");
var _vuePropertyDecorator = require("vue-property-decorator");
var PanelGroup = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(PanelGroup, _Vue);
  var _super = (0, _createSuper2.default)(PanelGroup);
  function PanelGroup() {
    var _this;
    (0, _classCallCheck2.default)(this, PanelGroup);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "date", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "orderType", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "revenueIcon", require("@/assets/images/increased-revenue.png"));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "profitIcon", require("@/assets/images/money-bag.png"));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "percentIcon", require("@/assets/images/discount.png"));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "data", {
      all: {},
      new: {},
      old: {}
    });
    return _this;
  }
  (0, _createClass2.default)(PanelGroup, [{
    key: "percentAll",
    get: function get() {
      var n = this.data.all.totalProfit / this.data.all.totalPrice * 100;
      if (!isNaN(n)) {
        return n.toFixed(2);
      }
      return 0;
    }
  }, {
    key: "percentNew",
    get: function get() {
      var n = this.data.new.totalProfit / this.data.new.totalPrice * 100;
      if (!isNaN(n)) {
        return n.toFixed(2);
      }
      return 0;
    }
  }, {
    key: "percentOld",
    get: function get() {
      var n = this.data.old.totalProfit / this.data.old.totalPrice * 100;
      if (!isNaN(n)) {
        return n.toFixed(2);
      }
      return 0;
    }
  }, {
    key: "watchDate",
    value: function watchDate() {
      this.fetchData();
    }
  }, {
    key: "watchOrderType",
    value: function watchOrderType() {
      this.fetchData();
    }
  }, {
    key: "fetchData",
    value: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var query, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                query = {
                  fromDate: this.date.from,
                  toDate: this.date.to,
                  orderType: this.orderType
                };
                _context.next = 3;
                return _report.reportApi.profit(query);
              case 3:
                res = _context.sent;
                this.data = res.data;
              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }()
  }]);
  return PanelGroup;
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], PanelGroup.prototype, "date", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], PanelGroup.prototype, "orderType", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("date", {
  immediate: true
})], PanelGroup.prototype, "watchDate", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("orderType")], PanelGroup.prototype, "watchOrderType", null);
PanelGroup = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], PanelGroup);
var _default = PanelGroup;
exports.default = _default;